import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { logoutAdmin } from "../../services/authService";
import { logout } from "../../redux/authSlice";
import Modal from "../../components/ui/Modal";
import Button from "../../components/ui/Button";

const LogoutButton: React.FC<{ className?: string; children?: React.ReactNode }> = ({ className, children = "Logout" }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const dispatch = useDispatch();
  const close = () => { if (!busyRef.current) { setOpen(false); triggerRef.current?.focus(); } };
  const confirm = async () => {
    if (busyRef.current) return;
    busyRef.current = true; setBusy(true);
    try { await logoutAdmin(); } catch { /* Local logout still completes after a network failure. */ }
    finally { dispatch(logout()); window.location.assign("/login"); }
  };
  return <><button ref={triggerRef} type="button" className={className} onClick={() => setOpen(true)}>{children}</button>
    {open && <Modal title="Log out?" size="small" dismissible={!busy} onClose={close}
      footer={<><Button data-autofocus="true" disabled={busy} onClick={close}>Cancel</Button><Button variant="primary" disabled={busy} onClick={confirm}>{busy ? "Logging out..." : "Log out"}</Button></>}>
      <p className="navo-confirm__description">You’ll need to sign in again to access your admin account.</p>
    </Modal>}
  </>;
};
export default LogoutButton;
